(function (window) {
    class Modal {
        constructor(modalId, options = {}) {
            this.modalId = modalId;
            this.modal = document.getElementById(modalId);
            this.overlay = this.modal?.querySelector(".checkout-modal-overlay");
            this.closeBtn = this.modal?.querySelector(".checkout-modal-close");

            this.onOpen = options.onOpen || null;
            this.onClose = options.onClose || null;

            this.init();
        }

        init() {
            if (!this.modal) {
                console.error("Modal not found:", this.modalId);
                return;
            }

            if (this.closeBtn) {
                this.closeBtn.addEventListener("click", () => this.close());
            }

            if (this.overlay) {
                this.overlay.addEventListener("click", () => this.close());
            }

            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape" && this.isOpen()) {
                    this.close();
                }
            });
        }

        open() {
            if (!this.modal) return;

            this.modal.style.display = "flex";

            requestAnimationFrame(() => {
                this.modal.classList.add("is-active");
                document.body.classList.add("modal-open");
            });

            if (typeof this.onOpen === "function") {
                this.onOpen();
            }
        }

        close() {
            if (!this.modal) return;

            this.modal.classList.remove("is-active");
            document.body.classList.remove("modal-open");

            setTimeout(() => {
                this.modal.style.display = "none";

                if (typeof this.onClose === "function") {
                    this.onClose();
                }
            }, 300);
        }

        isOpen() {
            return this.modal?.classList.contains("is-active");
        }

        focusFirstInput() {
            const input = this.modal?.querySelector("input, textarea, select");
            if (input) {
                setTimeout(() => input.focus(), 300);
            }
        }
    }

    window.Modal = Modal;
})(window);

document.addEventListener("DOMContentLoaded", () => {
    function setupModal(triggerId, modalId) {
        const trigger = document.getElementById(triggerId);
        if (!trigger) return;

        const modal = new window.Modal(modalId, {
            onOpen: () => modal.focusFirstInput(),
        });

        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            modal.open();
        });
    }
});

document.addEventListener("DOMContentLoaded", () => {
    // Initialize form modals
    function initFormModal(triggerId, modalId) {
        const trigger = document.getElementById(triggerId);
        if (!trigger) return;

        const modal = new window.Modal(modalId);
        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            modal.open();
        });
        return modal;
    }

    const therapistsModalInstance = initFormModal(
        "openTherapistsModal",
        "therapistsModal",
    );

    const patientsModalInstance = initFormModal(
        "openPatientsModal",
        "patientsModal",
    );

    async function ajaxFormSubmit(formId, parentModalInstance, formType) {
        const form = document.getElementById(formId);
        if (!form) return;

        form.addEventListener("submit", async (e) => {
            e.preventDefault();

            const formData = new FormData(form);

            const response = await fetch(form.action, {
                method: "POST",
                body: formData,
            });

            const result = await response.json();

            if (result.redirect) {
                window.location.href = result.redirect;
                return;
            }

            // Close modal if form came from a modal
            if (parentModalInstance && parentModalInstance.isOpen()) {
                parentModalInstance.close();
            }

            // Load result modal if not already present
            let resultModal = document.getElementById("resultModal");

            if (!resultModal) {
                const modalHtmlResponse = await fetch(
                    "php/modals/result_modal.php",
                );
                const modalHtml = await modalHtmlResponse.text();

                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = modalHtml.trim();

                document.body.appendChild(tempDiv.firstChild);

                resultModal = document.getElementById("resultModal");
            }

            const modal = new window.Modal("resultModal");
            modal.modal.style.display = "flex";
            modal.open();

            const loadingDiv = modal.modal.querySelector(".modal-loading");
            const modalResult = modal.modal.querySelector(".modal-result");
            const lisaCard = modal.modal.querySelector("#lisaCard");
            const alexCard = modal.modal.querySelector("#alexCard");
            const messageP = modal.modal.querySelector(".modal-message");

            loadingDiv.style.display = "flex";
            modalResult.style.display = "none";
            lisaCard.style.display = "none";
            alexCard.style.display = "none";

            setTimeout(() => {
                loadingDiv.style.display = "none";

                modalResult.style.display = "flex";
                modalResult.style.flexDirection = "column";
                modalResult.style.alignItems = "center";
                modalResult.style.justifyContent = "center";
                modalResult.style.opacity = 0;
                modalResult.style.transition = "opacity 0.5s ease-in";

                if (formType === "therapists" || formType === "patients") {
                    lisaCard.style.display = "block";
                    messageP.textContent =
                        "Your therapist is contacting you soon via Email.";
                } else if (formType === "contact") {
                    alexCard.style.display = "block";
                    messageP.textContent = 
                        "Our COO is contacting you soon via Email.";
                }

                requestAnimationFrame(() => {
                    modalResult.style.opacity = 1;
                });

                setTimeout(() => {
                    modal.close();
                }, 6000);

            }, 2500);

            form.reset();
        });
    }

    ajaxFormSubmit("therapistsForm", therapistsModalInstance, "therapists");
    ajaxFormSubmit("patientsForm", patientsModalInstance, "patients");
    ajaxFormSubmit("contactForm", null, "contact");
});
